import { render, staticRenderFns } from "./FormInvite.vue?vue&type=template&id=20d3abd1&"
import script from "./FormInvite.vue?vue&type=script&lang=js&"
export * from "./FormInvite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports